(function () {
  let subscriptionCartUpdating = false;
  let subscriptionValidationInProgress = false;
  let subscriptionPopupOpen = false;
  let subscriptionStateSaveTimeout = null;
  const SUBSCRIPTION_STORAGE_KEY = 'subscription_cart_state';
  function getStoredSubscriptionState() {
    try {
      return JSON.parse(localStorage.getItem(SUBSCRIPTION_STORAGE_KEY) || '{}');
    } catch (e) {
      return {};
    }
  }

  function saveSubscriptionState(items) {
    const subscriptionItems = {};
    items.forEach((item) => {
      if (!item.selling_plan_allocation) {
        return;
      }

      subscriptionItems[item.key] = {
        key: item.key,
        variant_id: item.variant_id,
        quantity: item.quantity,
        product_title: item.product_title,
        variant_title: item.variant_title,
        product_id: item.product_id,
        selling_plan_id: item.selling_plan_allocation?.selling_plan?.id,
        selling_plan_name: item.selling_plan_allocation?.selling_plan?.name
      };
    });

    localStorage.setItem(SUBSCRIPTION_STORAGE_KEY, JSON.stringify(subscriptionItems));
  }

  function waitForSmartCart(callback) {
    const interval = setInterval(() => {
      const SmartCart = window.Rebuy?.SmartCart;
      if (SmartCart?.cart?.items) {
        clearInterval(interval);
        callback(SmartCart);
      }
    }, 300);
  }

  function getRequiredSubscriptionQuantity(item) {
    const planName = item?.selling_plan_allocation?.selling_plan?.name || '';
    const cleanedName = planName.replace(/^Subscribe\s*&\s*Save/i, '').replace(/\d+%/g, '').trim();
    const quantityMatch = cleanedName.match(/(\d+)\s*(Tub|Tubs|Box|Boxes|Bottle|Bottles|Pack|Packs|Jar|Jars|Bag|Bags)\b/i);
    return quantityMatch ? parseInt(quantityMatch[1], 10) : 1;
  }

  function getVariantQuantityMap(items) {
    const map = {};
    items.forEach((item) => {
      if (!map[item.variant_id]) {
        map[item.variant_id] = 0;
      }
      map[item.variant_id] += item.quantity;
    });
    return map;
  }

  function getVariantDeltaMap(currentMap, previousMap) {
    const deltaMap = {};
    const allVariantIds = [
      ...new Set([
        ...Object.keys(currentMap),
        ...Object.keys(previousMap)
      ])
    ];
    allVariantIds.forEach((variantId) => {
      const currentQty = currentMap[variantId] || 0;
      const previousQty = previousMap[variantId] || 0;
      deltaMap[variantId] = currentQty - previousQty;
    });
    return deltaMap;
  }

  function validateSubscriptionCart(SmartCart, triggerType = 'cart_update') {
    const items = SmartCart.cart.items;
    window.subscriptionPreviousState = window.subscriptionPreviousState || {};
    const groupedItems = {};
    items.forEach((item) => {
      if (!item.selling_plan_allocation) {
        return;
      }
      const sellingPlan = item.selling_plan_allocation?.selling_plan;
      const sellingPlanId = sellingPlan?.id || 'none';
      const sellingPlanName = sellingPlan?.name || 'Subscription';
      const groupKey = `${item.product_id}_${sellingPlanId}`;
      if (!groupedItems[groupKey]) {
        groupedItems[groupKey] = {
          requiredQty: getRequiredSubscriptionQuantity(item),
          currentQty: 0,
          items: [],
          sellingPlanName,
          variantSignature: [],
        };
      }
      groupedItems[groupKey].currentQty += item.quantity;
      groupedItems[groupKey].items.push(item);
      groupedItems[groupKey].variantSignature.push({
        variant_id: item.variant_id,
        quantity: item.quantity,
        key: item.key
      });
    });

    Object.entries(groupedItems).forEach(
      ([groupKey, group]) => {
        const {
          requiredQty,
          currentQty,
          items,
          sellingPlanName,
        } = group;
        if (requiredQty === 1) {
          const variantMap = {};
          items.forEach((item) => {
            if (!variantMap[item.variant_id]) {
              variantMap[item.variant_id] = 0;
            }
            variantMap[item.variant_id] += item.quantity;
          });

          const duplicateItems = [];
          Object.entries(variantMap).forEach(([variantId, qty]) => {
            if (qty > 1) {
              const matchedItems = items.filter((item) => {
                return (String(item.variant_id) === String(variantId));
              });
              duplicateItems.push(
                ...matchedItems
              );
            }
          });
          if (duplicateItems.length) {
            openSubscriptionPopup({
              title: 'Subscription Already In Cart',
              message: `"${sellingPlanName}" only allows one quantity of the same subscription product in cart.`,
              confirmText: 'OK',
              hideCancel: true,
              onConfirm: async () => {
                subscriptionCartUpdating = true;
                subscriptionValidationInProgress = true;
                const updates = [];
                duplicateItems.forEach((item) => {
                  updates.push({
                    id: item.key,
                    quantity: 1
                  });
                });

                await bulkUpdateCartItems(updates);
                await refreshCartUI();
                await finalizeSubscriptionState();
                lastValidatedCartSignature = '';
                subscriptionValidationInProgress = false;
                subscriptionCartUpdating = false;
              }
            });
            return;
          }
          if (items.length > 1) {
            const storedState = getStoredSubscriptionState();
            let oldItem = items[0];
            let newItem = items[items.length - 1];
            items.forEach((item) => {
              if (storedState[item.key]) {
                oldItem = item;
              } else {
                newItem = item;
              }
            });

            openSubscriptionPopup({
              title: 'Only One Subscription Allowed',
              message: `For "${sellingPlanName}" only one subscription option is allowed.\n\nPlease select which option you want to keep.`,
              confirmText: `Keep ${oldItem.variant_title}`,
              cancelText: `Keep ${newItem.variant_title}`,
              onConfirm: async () => {
                subscriptionCartUpdating = true;
                subscriptionValidationInProgress = true;
                await fetch('/cart/change.js', {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                  },
                  body: JSON.stringify({
                    id: newItem.key,
                    quantity: 0
                  })
                });
                await refreshCartUI();
                await finalizeSubscriptionState();
                lastValidatedCartSignature = '';
                subscriptionValidationInProgress = false;
                subscriptionCartUpdating = false;
              },
              onCancel: async () => {
                subscriptionCartUpdating = true;
                subscriptionValidationInProgress = true;
                await fetch('/cart/change.js', {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                  },
                  body: JSON.stringify({
                    id: oldItem.key,
                    quantity: 0
                  })
                });
                await refreshCartUI();
                await finalizeSubscriptionState();
                lastValidatedCartSignature = '';
                subscriptionValidationInProgress = false;
                subscriptionCartUpdating = false;
              }
            });
          }
          return;
        }

        if (currentQty > requiredQty) {
          const storedState = getStoredSubscriptionState();
          const previousItems = Object.values(storedState).filter((storedItem) => {
            return (storedItem.product_id === items[0].product_id && storedItem.selling_plan_id === items[0].selling_plan_allocation?.selling_plan?.id);
          });
          const currentVariantMap = getVariantQuantityMap(items);
          const previousVariantMap = getVariantQuantityMap(previousItems);
          const variantDeltaMap = getVariantDeltaMap(currentVariantMap, previousVariantMap);
          const previousTotalQty = Object.values(previousVariantMap).reduce((sum, qty) => { return sum + qty; }, 0);
          const currentTotalQty = Object.values(currentVariantMap).reduce((sum, qty) => { return sum + qty; }, 0);
          const previousVariantCount = Object.keys(previousVariantMap).length;
          const currentVariantCount = Object.keys(currentVariantMap).length;
          const sameConfiguration = previousVariantCount === currentVariantCount && Object.keys(previousVariantMap).every((variantId) => {
            return (currentVariantMap[variantId] !== undefined);
          });
          const proportionalIncrease = Object.keys(previousVariantMap).every((variantId) => {
            const previousQty = previousVariantMap[variantId];
            const currentQty = currentVariantMap[variantId];
            if (currentQty <= previousQty) return false;
            const ratio = currentQty / previousQty;
            if (!window.__subscriptionRatio) {
              window.__subscriptionRatio = ratio;
            }
            return (ratio === window.__subscriptionRatio);
          });

          window.__subscriptionRatio = null;

          const quantityOnlyChanged = sameConfiguration && currentTotalQty > previousTotalQty && proportionalIncrease;
          const quantityConfigurationChanged = sameConfiguration && currentTotalQty > previousTotalQty && !proportionalIncrease;
          const hasNewConfiguration = !sameConfiguration || quantityConfigurationChanged;
          if (quantityOnlyChanged && !hasNewConfiguration) {
            openSubscriptionPopup({
              title: 'Subscription Already In Cart',
              message: `"${sellingPlanName}" already exists in cart with this configuration.\n\nOnly ${requiredQty} total products are allowed.`,
              confirmText: 'OK',
              hideCancel: true,
              onConfirm: async () => {
                subscriptionCartUpdating = true;
                subscriptionValidationInProgress = true;
                const updates = [];
                for (const item of items) {
                  const previousQty = previousVariantMap[item.variant_id];
                  if (previousQty === undefined) continue;
                  if (item.quantity > previousQty) {
                    updates.push({
                      id: item.key,
                      quantity: previousQty
                    });
                  }
                }
                await bulkUpdateCartItems(updates);
                await refreshCartUI();
                await finalizeSubscriptionState();
                lastValidatedCartSignature = '';
                subscriptionValidationInProgress = false;
                subscriptionCartUpdating = false;
              }
            });
            return;
          }
          const existingItems = [];
          const newItems = [];
          items.forEach((item) => {
            const previousQty = previousVariantMap[item.variant_id] || 0;
            if (previousQty === 0) {
              existingItems.push({
                ...item,
                splitQuantity:
                  item.quantity
              });
              return;
            }
            if (item.quantity > previousQty) {
              newItems.push({
                ...item,
                splitQuantity:
                  previousQty
              });
              existingItems.push({
                ...item,
                splitQuantity:
                  item.quantity -
                  previousQty
              });
              return;
            }
            newItems.push({
              ...item,
              splitQuantity:
                item.quantity
            });
          });

          openSubscriptionPopup({
            title: 'Replace Subscription Products?',
            message: `A different "${sellingPlanName}" configuration was added.\n\nPlease select which products you want to keep.`,
            confirmText: 'Keep New Products',
            cancelText: 'Keep Existing Products',
            onConfirm: async () => {
              subscriptionCartUpdating = true;
              subscriptionValidationInProgress = true;
              const updates = [];
              existingItems.forEach((item) => {
                updates.push({
                  id: item.key,
                  quantity: item.splitQuantity
                });
              });
              newItems.forEach((item) => {
                const remainingQty = item.quantity - item.splitQuantity;
                updates.push({
                  id: item.key,
                  quantity: remainingQty
                });
              });
              await bulkUpdateCartItems(updates);
              await refreshCartUI();
              await finalizeSubscriptionState();
              lastValidatedCartSignature = '';
              subscriptionValidationInProgress = false;
              subscriptionCartUpdating = false;
            },
            onCancel: async () => {
              subscriptionCartUpdating = true;
              subscriptionValidationInProgress = true;
              const updates = [];
              items.forEach((item) => {
                const matchedItem =
                  newItems.find((newItem) => {
                    return (String(newItem.variant_id) === String(item.variant_id));
                  });
                updates.push({
                  id: item.key,
                  quantity: matchedItem ? matchedItem.splitQuantity : 0
                });
              });
              await bulkUpdateCartItems(updates);
              await refreshCartUI();
              await finalizeSubscriptionState();
              lastValidatedCartSignature = '';
              subscriptionValidationInProgress = false;
              subscriptionCartUpdating = false;
            }
          });
          return;
        }

        if (currentQty < requiredQty) {
          const missingQty = requiredQty - currentQty;
          const onlyRemove = triggerType === 'initial_load';
          openSubscriptionPopup({
            title: 'Subscription Quantity Issue Detected',
            message: `"${sellingPlanName}" requires ${requiredQty} products.\n\nCurrently only ${currentQty} products are in cart. These extra products will be removed from your cart.`,
            confirmText: 'OK',
            hideCancel: true,
            onConfirm: async () => {
              subscriptionCartUpdating = true;
              subscriptionValidationInProgress = true;
              const updates = items.map((item) => {
                  return {
                    id: item.key,
                    quantity: 0
                  };
                });
              await bulkUpdateCartItems(updates);
              await refreshCartUI();
              await finalizeSubscriptionState();
              lastValidatedCartSignature = '';
              subscriptionValidationInProgress = false;
              subscriptionCartUpdating = false;
            },
            onCancel: async () => {
              const updates = items.map((item) => {
                return {
                  id: item.key,
                  quantity: 0
                };
              });
              await bulkUpdateCartItems(updates);
              await refreshCartUI();
              await finalizeSubscriptionState();
              lastValidatedCartSignature = '';
              subscriptionValidationInProgress = false;
            }
          });
        }
        window.subscriptionPreviousState[groupKey] = {qty: currentQty, variantSignature: [...group.variantSignature]};
      }
    );
    if (!subscriptionCartUpdating && !subscriptionValidationInProgress && !subscriptionPopupOpen) {
      scheduleSubscriptionStateSave();
    }
  }

  async function refreshCartUI() {
    document.dispatchEvent(new CustomEvent('theme:cart:refresh'));
    document.dispatchEvent(new CustomEvent('theme:cart:updated'));
    await window.Rebuy?.SmartCart?.fetchCart?.();
    await new Promise((resolve) => {
      setTimeout(resolve, 2000);
    });
  }

  async function finalizeSubscriptionState() {
    await new Promise((resolve) => {
      setTimeout(resolve, 2500);
    });
    const SmartCart = window.Rebuy?.SmartCart;
    if (!SmartCart?.cart?.items) return;
    
    saveSubscriptionState(SmartCart.cart.items);
  }

  function scheduleSubscriptionStateSave() {
    clearTimeout(subscriptionStateSaveTimeout);
    subscriptionStateSaveTimeout = setTimeout(async () => {
        if (subscriptionCartUpdating || subscriptionValidationInProgress || subscriptionPopupOpen) return;

        const SmartCart = window.Rebuy?.SmartCart;
        if (!SmartCart?.cart?.items) {
          return;
        }

        saveSubscriptionState(SmartCart.cart.items);
      }, 2500);
  }

  async function bulkUpdateCartItems(updates = []) {
    if (!updates.length) return;

    const updatePayload = {};
    updates.forEach((item) => {
      updatePayload[item.id] = item.quantity;
    });

    await fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        updates: updatePayload
      })
    });
  }

  function openSubscriptionPopup({
    title = '',
    message = '',
    confirmText = 'OK',
    cancelText = 'Cancel',
    hideCancel = false,
    onConfirm = null,
    onCancel = null
  }) {
    const existingPopup = document.querySelector('.subscription-cart-popup');
    if (existingPopup) existingPopup.remove();
    subscriptionPopupOpen = true;
    const popup = document.createElement('div');
    popup.className = 'subscription-cart-popup';
    popup.innerHTML = `
      <div class="subscription-cart-popup__overlay"></div>
      <div class="subscription-cart-popup__container">
        <div class="subscription-cart-popup__content">
          <div class="subscription-cart-popup__loader">
            <svg height="40" width="40" class="svg-loader">
              <circle r="16" cx="20" cy="20"></circle>
              <circle stroke-dasharray="87.96459430051421 87.96459430051421" r="16" cx="20" cy="20"></circle>
            </svg>
          </div>
          <div class="subscription-cart-popup__inner">
            <h3>${title}</h3>
            <p>${message.replace(/\n/g, '<br>')}</p>
            <div class="subscription-cart-popup__actions">
              ${
                !hideCancel
                  ? `<button class="subscription-popup-cancel">
                      <span class="text-link">${cancelText}</span>
                    </button>`
                  : ''
              }
              <span id="button" class="btn btn--solid btn--primary">
                <button class="subscription-popup-confirm">
                  <span>${confirmText}</span>
                </button>
              </span>
            </div>
          </div>
        </div>
      </div>
    `;
    document.body.appendChild(popup);
    document.dispatchEvent(new CustomEvent('theme:scroll:lock'));
    popup.querySelector('.subscription-popup-confirm')?.addEventListener('click', async () => {
      popup.classList.add('is-loading');
      if (onConfirm) {
        await onConfirm();
      }
      setTimeout(() => {
        popup.remove();
        subscriptionPopupOpen = false;
        document.dispatchEvent(new CustomEvent('theme:scroll:unlock'));
      }, 2200);
    });
    popup.querySelector('.subscription-popup-cancel')?.addEventListener('click', async () => {
      popup.classList.add('is-loading');
      if (onCancel) {
        await onCancel();
      }
      setTimeout(() => {
        popup.remove();
        subscriptionPopupOpen = false;
        document.dispatchEvent(new CustomEvent('theme:scroll:unlock'));
      }, 2000);
    });
  }

  let subscriptionValidationInitialized = false;
  let subscriptionValidationRunning = false;
  let lastValidatedCartSignature = '';
  function getCartSignature(items) {
    return items.map((item) => {
      return [
        item.key,
        item.quantity,
        item.selling_plan_allocation?.selling_plan?.id || ''
      ].join(':');
    }).sort().join('|');
  }

  function runSubscriptionValidation(triggerType = 'cart_update') {
    if (subscriptionCartUpdating || subscriptionValidationInProgress) return;
    if (subscriptionValidationRunning) return;

    const SmartCart = window.Rebuy?.SmartCart;
    if (!SmartCart?.cart?.items) return;

    const cartSignature = getCartSignature(SmartCart.cart.items);
    if (triggerType !== 'initial_load' && cartSignature === lastValidatedCartSignature) return;

    lastValidatedCartSignature = cartSignature;
    subscriptionValidationRunning = true;
    try {
      validateSubscriptionCart(SmartCart, triggerType);
    } catch (error) {
      console.error('[Subscription Validation Error]', error);
    }

    setTimeout(() => {
      subscriptionValidationRunning = false;
    }, 800);
  }

  function initGlobalSubscriptionValidation() {
    if (subscriptionValidationInitialized) return;

    subscriptionValidationInitialized = true;
    setTimeout(() => {
      runSubscriptionValidation('initial_load');
    }, 2000);

    document.addEventListener('rebuy:cart.change', function() {
        setTimeout(() => {
          runSubscriptionValidation('cart_update');
        }, 800);
      }
    );

    document.addEventListener('rebuy:smartcart.show', function() {
        setTimeout(() => {
          runSubscriptionValidation('cart_update');
        }, 800);
      }
    );

    document.addEventListener('rebuy:smartcart.ready', function() {
        setTimeout(() => {
          runSubscriptionValidation('cart_update');
        }, 800);
      }
    );

    document.addEventListener('click', function(event) {
        const qtyButton = event.target.closest('button.rebuy-cart__flyout-item-quantity-widget-button');
        const removeButton = event.target.closest('.rebuy-cart__flyout-item-remove');
        if (!qtyButton && !removeButton) return;

        setTimeout(() => {
          runSubscriptionValidation('cart_update');
        }, 1200);
      },
      true
    );

    document.addEventListener('change', function(event) {
        const qtyInput = event.target.closest('.rebuy-cart__flyout-item-quantity-widget input');
        if (!qtyInput) return;

        setTimeout(() => {
          runSubscriptionValidation('cart_update');
        }, 1200);
      },
      true
    );

    document.addEventListener('theme:cart:refresh', function() {
        setTimeout(() => {
          runSubscriptionValidation('cart_update');
        }, 1200);
      }
    );
  }

  document.addEventListener('DOMContentLoaded', function() {
      initGlobalSubscriptionValidation();
    }
  );

  window.addEventListener('load', function() {
      initGlobalSubscriptionValidation();
    }
  );

  waitForSmartCart(() => {
    initGlobalSubscriptionValidation();
  });
})();